import React, { useEffect, useState } from 'react';
import Client from '../../utils/network';
import { shallowEqual, useSelector } from 'react-redux';
import { Rootstate } from '../../store';

const HostToggle = () => {
    const [isActive, setIsActive] = useState(false);

    const { mapId, guildId, channelId } = useSelector((state: Rootstate) => ({
        mapId: state.map.mapId,
        channelId: state.auth.channelId,
        guildId: state.auth.guildId,
    }), shallowEqual);

    useEffect(() => {
        if(!mapId || mapId === '') return;
        Client.request(
            `/api/map/${mapId}/host`
            + `?channelId=${channelId as string}&guildId=${guildId as string}`,
            { method: 'get' },
        ).then(async (res) => {
            const { active } = await res.json() as { active: boolean };
            setIsActive(active);
            return;
        }).catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
        });
    }, [mapId, guildId, channelId]);

    const onClick = () => {
        if(!mapId || mapId === '') return;
        Client.request(`/api/map/${mapId}/host`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                active: !isActive,
                channelId,
                guildId,
            })},
        ).then(() => {
            setIsActive(!isActive);
            return;
        }).catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
        });
    };
    return guildId && channelId ? (
        <div className="absolute top-6 right-32 bg-deep-blue rounded-xl p-2 text-white">
            <button
                onClick={onClick}
                className='block p-2 m-2 rounded-xl bg-mid-blue'
                disabled={!channelId || !guildId}
            >
                {isActive ? 'De-Host' : 'Host'}
            </button>
        </div>
    ) : null;
};

export default HostToggle;
